export default __webpack_public_path__ + "marketing-strategy.png";